// extracted by mini-css-extract-plugin
export var button = "transition-team-member-card-module--button--r0+tU";
export var container = "transition-team-member-card-module--container--7nBu-";
export var description = "transition-team-member-card-module--description--nwPD2";
export var name = "transition-team-member-card-module--name--I9ywD";
export var role = "transition-team-member-card-module--role--qRZsb";